import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';

import { AppStatus, Maintenance } from './status.model';

@Injectable()
export class StatusPageApi {
  private readonly endPointPrefix = 'status';
  constructor(private clientService: ClientService) {}

  /**
   * Returns status of the app
   * @param appId
   */
  getAppStatus(appId: string): Observable<AppStatus> {
    const ver = 'v1';
    const endpoint = `${this.endPointPrefix}/${ver}/apps/${appId}/summary`;

    return this.clientService.get(endpoint);
  }

  /**
   * Returns upcoming maintenances
   */
  getMaintenances(): Observable<Maintenance[]> {
    const ver = 'v1';
    const endpoint = `${this.endPointPrefix}/${ver}/maintenances`;

    return this.clientService.get(endpoint);
  }
}
